import { Anchor, type AnchorProps } from "@newsela/angelou";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";

type LinkProps = AnchorProps & NextLinkProps;

export const Link = (props: LinkProps) => {
  return (
    <Anchor
      {...props}
      __renderCustomLink={(renderCustomLinkProps) => {
        return (
          <NextLink
            {...renderCustomLinkProps}
            href={renderCustomLinkProps.href ?? ""}
          />
        );
      }}
    >
      {props.children}
    </Anchor>
  );
};

export default Link;
